import backsideExploded from '../assets/images/drawing-backside-exploded-2021.webp'
import elephantDreams from '../assets/images/drawing-elephant-dreams-2021.webp'
import planetarySuburb from '../assets/images/drawing-planetary-suburb-2021.webp'
import dwellings from '../assets/images/drawing-dwellings-2020.webp'
import courtyardObservations from '../assets/images/drawing-courtyard-observations-2020.webp'
import figure from '../assets/images/drawing-figure-2020.webp'
import leftover from '../assets/images/drawing-leftover-2020.webp'

import gw1 from '../assets/images/drawing-gw1-2023.webp'
import gw2 from '../assets/images/drawing-gw2-2023.webp'
import gw3 from '../assets/images/drawing-gw3-2023.webp'
import gw4 from '../assets/images/drawing-gw4-2023.webp'
import gw5 from '../assets/images/drawing-gw5-2023.webp'
import gw6 from '../assets/images/drawing-gw6-2023.webp'
import gw7 from '../assets/images/drawing-gw7-2023.webp'
import gw8 from '../assets/images/drawing-gw8-2023.webp'
import gw9 from '../assets/images/drawing-gw9-2023.webp'
import gw10 from '../assets/images/drawing-gw10-2023.webp'
import gw11 from '../assets/images/drawing-gw11-2023.webp'

import isit1 from '../assets/images/drawing-isit1-2021.webp'
import isit2 from '../assets/images/drawing-isit2-2021.webp'
import isit3 from '../assets/images/drawing-isit3-2021.webp'
import isit4 from '../assets/images/drawing-isit4-2021.webp'
import isit5 from '../assets/images/drawing-isit5-2021.webp'

export const drawingImages = [
    {
        src: backsideExploded,
        alt: "",
        title: "Backside of an exploded earth",
        dimension: '8" x 9"',
        material: "Oil monoprint and soft pastel on paper",
        year: "2021"
    },
    {
        src: elephantDreams,
        alt: "",
        title: "Elephant dreams",
        material: "Acrylic stencil, glitter, and thread on paper",
        year: "2021"
    },
    {
        src: planetarySuburb,
        alt: "",
        title: "Planetary suburb",
        dimension: '8" x 9"',
        material: "Oil monoprint and soft pastel on paper",
        year: "2021"
    },
    {
        src: dwellings,
        alt: "",
        title: "Dwellings",
        dimension: '9" x 14"',
        material: "Acrylic and ink on paper",
        year: "2021"
    },
    {
        src: courtyardObservations,
        alt: "",
        title: "Courtyard observations",
        dimension: '9" x 7"',
        material: "Silver point and open flame on paper",
        year: "2020"
    },
    {
        src: figure,
        alt: "",
        title: "Figure drawing",
        material: "Conte and soft pastel on paper",
        year: "2020"
    },
    {
        src: leftover,
        alt: "",
        title: "The leftover",
        dimension: '9" x 7"',
        material: "Acrylic and ink on paper",
        year: "2020"
    }    
]

export const drawingSeries = [
    {
        category: "drawing",
        id: "groundwater-series",
        cover: gw1,
        title: "Ground(water)",
        dimension: '8" x 11"',
        material: "Soft pastel and oil paint on arches oil paper",
        year: "2023",
        description: `Ground(water) is a series of soft pastel on oil paint monotypes dedicated to the tough and tender
        terrain of the Hawaiian coastline. Inspired by ahupu'a networks of fresh and brackish ponds, traditional rock-walls by
        the shoreline, and other features that curate accessible water, the drawings seek to define resistance in nature as invasive
        species, urban clearing and pollutants become regular sights to behold.`,
        images: [
            {
                src: gw1,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw2,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw3,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw4,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw5,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw6,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw7,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw8,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw9,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw10,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            },
            {
                src: gw11,
                alt: "",
                title: "",
                dimension: '',
                material: "Soft pastel and oil paint on arches oil paper",
                year: "2023",
            }
        ]
    },
    {
        category: "drawing",
        id: "in-summer-i-will-tear-series",
        cover: isit1,
        title: "In summer I'll tear",
        material: "Ink, crayon, and graphite on hanji",
        year: "2021",
        description: `I was born in June, just before harvest season. Come wintertime, the garden beds are left empty like lying caskets.
        Suffering from the symptoms of an insistent longing, lies a winded house of splintered corners, rubber pipe, and dried peel. The
        red that I call home finds shleter in the padded dirt, quiet and asleep underneath the nipping cold. And as the sun beckons all
        life underneath it, the red eventually comes — first from the dirt, then into me.`,
        images: [
            {
                src: isit1,
                alt: "",
                title: "In summer I'll tear",
                material: "Ink, crayon, and graphite on hanji",
                year: "2021",
            },
            {
                src: isit2,
                alt: "",
                title: "In summer I'll tear",
                material: "Ink, crayon, and graphite on hanji",
                year: "2021",
            },
            {
                src: isit3,
                alt: "",
                title: "In summer I'll tear",
                material: "Ink, crayon, and graphite on hanji",
                year: "2021",
            },
            {
                src: isit4,
                alt: "",
                title: "In summer I'll tear",
                material: "Ink, crayon, and graphite on hanji",
                year: "2021",
            },
            {
                src: isit5,
                alt: "",
                title: "In summer I'll tear",
                material: "Ink, crayon, and graphite on hanji",
                year: "2021",
            }
        ]
    }
]

